import { hasPermission } from "@/utils/authModel";
export default {
  inserted(el, binding, vnode) {
    const { value } = binding; // v-permission 绑定的权限值
    // let checkFlag = hasPermission(value);
    // 没加权限暂时认为都是true
    let checkFlag = true;
    if (checkFlag == false && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  },
};
